import React, { useEffect, useState } from "react";
import { CookiesProvider, withCookies } from "react-cookie";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import Header from "./Header/Header";
import Footer from "./Footer/Footer";

import "styles/app.scss";
import CookiesBanner from "./CookiesBanner/CookiesBanner";
import PopupInfo from "./PopupInfo";

const Layout = ({ children, cookies, is404 }) => {
	const [cookieBaner, setCookieBaner] = useState(true);
	const [cookiePopupInfo, setCookiePopupInfo] = useState(true);

	useEffect(() => {
		const isAcceptedCoookie = cookies.get("elcampCookie");
		isAcceptedCoookie && setCookieBaner(false);

		const isAcceptedCoookiePopupInfo = cookies.get("elcampCookiePopupInfo");
		isAcceptedCoookiePopupInfo && setCookiePopupInfo(false);
	}, []);

	const acceptCookieBaner = () => {
		const promiseSetCookie = new Promise((resolve) =>
			resolve(cookies.set("elcampCookie", "active", { path: "/" }))
		);
		promiseSetCookie.then(() => {
			setCookieBaner(false);
		});
	};

	const acceptCookiePopupInfo = () => {
		const promiseSetCookie = new Promise((resolve) =>
			resolve(
				cookies.set("elcampCookiePopupInfo", "active", { path: "/" })
			)
		);
		promiseSetCookie.then(() => {
			setCookiePopupInfo(false);
		});
	};

	return (
		<CookiesProvider>
			<GoogleReCaptchaProvider reCaptchaKey="6Le3K7MiAAAAAJScR2QcmzsxySj2CCQ6Edg_O2qq">
				<Header />
				<main>{children}</main>
				{!is404 && <Footer />}
				{cookieBaner && <CookiesBanner onClick={acceptCookieBaner} />}
				{cookiePopupInfo && (
					<PopupInfo onClick={acceptCookiePopupInfo} />
				)}
			</GoogleReCaptchaProvider>
		</CookiesProvider>
	);
};

export default withCookies(Layout);
